import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";
import InlineIcon from "../InlineIcon.svelte";

var root = $.from_html(`<span> </span>`);
var root_1 = $.from_html(`<span class="slex-code-block-language"> </span>`);
var root_2 = $.from_html(`<figcaption class="slex-code-block-header"><span class="slex-code-block-title"><!> <!></span> <!></figcaption>`);
var root_3 = $.from_html(`<span class="slex-code-line"><span class="slex-code-line-content"></span></span>`);
var root_4 = $.from_html(`<figure class="slex-code-block"><!> <pre class="slex-code-block-pre"><code></code></pre></figure>`);

export default function CodeBlock($$anchor, $$props) {
	$.push($$props, true);

	const supportedLanguages = new Set([
		"bash",
		"css",
		"html",
		"javascript",
		"js",
		"json",
		"markdown",
		"md",
		"python",
		"py",
		"sh",
		"shell",
		"sql",
		"ts",
		"tsx",
		"typescript",
		"xml",
		"yaml",
		"yml"
	]);

	const keywordLanguages = new Set(["javascript", "js", "ts", "tsx", "typescript"]);

	const keywords = new Set([
		"as",
		"async",
		"await",
		"break",
		"case",
		"catch",
		"class",
		"const",
		"continue",
		"default",
		"do",
		"else",
		"export",
		"extends",
		"finally",
		"for",
		"from",
		"function",
		"if",
		"import",
		"in",
		"interface",
		"let",
		"new",
		"of",
		"return",
		"switch",
		"throw",
		"try",
		"type",
		"var",
		"while"
	]);

	const literals = new Set(["false", "null", "true", "undefined"]);
	const tokenPattern = /\/\/[^\n]*|\/\*[\s\S]*?\*\/|"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|`(?:\\.|[^`\\])*`|\r\n|\r|\n|\b\d+(?:\.\d+)?\b|\b[$A-Z_a-z][$\w]*\b|./g;
	let p = $.state($.proxy({}));
	let code = $.derived(() => text($.get(p).code ?? $.get(p).content ?? $.get(p).source));
	let languageName = $.derived(() => text($.get(p).language).trim().toLowerCase());
	let languageClass = $.derived(() => $.get(languageName) === "js" ? "javascript" : $.get(languageName) || "");
	let lines = $.derived(() => highlightCode($.get(code), $.get(languageName)) ?? plainCodeLines($.get(code)));
	let highlighted = $.derived(() => supportedLanguages.has($.get(languageName)));
	let showLineNumbers = $.derived(() => $.get(p).lineNumbers !== false && $.get(p).lineNumbers !== "false");

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	function highlightCode(source, language) {
		if (!supportedLanguages.has(language)) return null;

		const tokens = Array.from(source.matchAll(tokenPattern), ([value]) => {
			if (value.startsWith("//") || value.startsWith("/*")) return { text: value, kind: "comment" };
			if ((/^["'`]/).test(value)) return { text: value, kind: "string" };
			if ((/^\d/).test(value)) return { text: value, kind: "number" };
			if (literals.has(value)) return { text: value, kind: "literal" };
			if (keywordLanguages.has(language) && keywords.has(value)) return { text: value, kind: "keyword" };

			return { text: value };
		});

		return splitTokenLines(tokens);
	}

	function plainCodeLines(source) {
		return splitTokenLines([{ text: source }]);
	}

	function splitTokenLines(tokens) {
		const lines = [[]];

		for (const token of tokens) {
			for (const part of token.text.split(/(\r\n|\r|\n)/)) {
				if (!part) continue;

				if (part === "\n" || part === "\r" || part === "\r\n") {
					lines.push([]);
				} else {
					lines[lines.length - 1].push({ ...token, text: part });
				}
			}
		}

		return lines;
	}

	var figure = root_4();
	var node = $.child(figure);

	{
		var consequent_3 = ($$anchor) => {
			var figcaption = root_2();
			var span = $.child(figcaption);
			var node_1 = $.child(span);

			{
				var consequent = ($$anchor) => {
					InlineIcon($$anchor, {
						get name() {
							return $.get(p).icon;
						},
						className: 'slex-code-block-icon'
					});
				};

				$.if(node_1, ($$render) => {
					if ($.get(p).icon) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var span_1 = root();
					var text_1 = $.child(span_1, true);

					$.reset(span_1);
					$.template_effect(($0) => $.set_text(text_1, $0), [() => text($.get(p).title)]);
					$.append($$anchor, span_1);
				};

				$.if(node_2, ($$render) => {
					if ($.get(p).title) $$render(consequent_1);
				});
			}

			$.reset(span);

			var node_3 = $.sibling(span, 2);

			{
				var consequent_2 = ($$anchor) => {
					var span_2 = root_1();
					var text_2 = $.child(span_2, true);

					$.reset(span_2);
					$.template_effect(($0) => $.set_text(text_2, $0), [() => text($.get(p).language)]);
					$.append($$anchor, span_2);
				};

				$.if(node_3, ($$render) => {
					if ($.get(p).language) $$render(consequent_2);
				});
			}

			$.reset(figcaption);
			$.append($$anchor, figcaption);
		};

		$.if(node, ($$render) => {
			if ($.get(p).title || $.get(p).language || $.get(p).icon) $$render(consequent_3);
		});
	}

	var pre = $.sibling(node, 2);
	var code_1 = $.child(pre);

	$.each(code_1, 21, () => $.get(lines), $.index, ($$anchor, line) => {
		var span_3 = root_3();
		var span_4 = $.child(span_3);

		$.each(span_4, 21, () => $.get(line), $.index, ($$anchor, token) => {
			var fragment_1 = $.comment();
			var node_4 = $.first_child(fragment_1);

			{
				var consequent_4 = ($$anchor) => {
					var span_5 = root();
					var text_3 = $.child(span_5, true);

					$.reset(span_5);

					$.template_effect(() => {
						$.set_class(span_5, 1, `slex-code-token slex-code-token--${$.get(token).kind}`);
						$.set_text(text_3, $.get(token).text);
					});

					$.append($$anchor, span_5);
				};

				var alternate = ($$anchor) => {
					var text_4 = $.text();

					$.template_effect(() => $.set_text(text_4, $.get(token).text));
					$.append($$anchor, text_4);
				};

				$.if(node_4, ($$render) => {
					if ($.get(token).kind) $$render(consequent_4); else $$render(alternate, -1);
				});
			}

			$.append($$anchor, fragment_1);
		});

		$.reset(span_4);
		$.reset(span_3);
		$.append($$anchor, span_3);
	});

	$.reset(code_1);
	$.reset(pre);
	$.reset(figure);

	$.template_effect(
		($0) => {
			$.set_class(code_1, 1, $0);
			$.set_attribute(code_1, 'data-line-numbers', $.get(showLineNumbers) ? "true" : "false");
		},
		[
			() => $.clsx(`${$.get(highlighted) ? "slex-code-highlight" : ""} slex-code-lines${$.get(p).language
				? ` language-${$.get(highlighted) ? $.get(languageClass) : text($.get(p).language)}`
				: ""}`.trim())
		]
	);

	$.append($$anchor, figure);
	$.pop();
}